/**
 * Backend uses `notarial_certificate` for the delivered certificate in both notary and accountant flows.
 * Labels differ by who fulfilled the request.
 */
export type NotarialCertificateLabelContext = "notary" | "accountant";

const NOTARIAL_CERTIFICATE = "notarial_certificate";

export function notarialDocumentTypeTranslationKey(
  documentType: string,
  certificateContext: NotarialCertificateLabelContext,
): string {
  if (documentType === NOTARIAL_CERTIFICATE && certificateContext === "accountant") {
    return "notary.requestDetail.documentType_notarial_certificate_accountant";
  }
  return `notary.requestDetail.documentType_${documentType}`;
}
